enum TransactionType {
  Sale = 0,
  Refund = 1,
}

export { TransactionType };
